import React from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { StyledEngineProvider } from "@mui/material";
import { MeshGradient, NavigationBar } from "../../components";
import { LoginContainer, LoginOrRegisterContainer } from "./Login.styles";
import { LoginForm } from "../../components/Login";

interface LoginProps extends WithRouterProps {
}

const Login: React.FC<LoginProps> = ({
    router,
    ...rest
}) => {
    const { query } = router;
    // Every caller pushes `redirectURL` (loginRedirect, the last-min landing page, the
    // expired-offer panel). Reading `redirectUrl` here meant the prop was always empty and
    // the round trip silently dropped users on /profile.
    const redirectURLParam = query.redirectURL;
    const redirectURL = typeof redirectURLParam === 'string' ? redirectURLParam : '';
 
    return (
        <StyledEngineProvider injectFirst>
            <NavigationBar showMenu={true} showLoginButton={false} />
            <LoginContainer>
                <LoginOrRegisterContainer>
                    <LoginForm redirectURL={redirectURL} {...rest} />
                </LoginOrRegisterContainer>
                <MeshGradient sx={{ position: 'fixed' }} colour={"teal-green"} position="bottom" size="low" />
            </LoginContainer>
        </StyledEngineProvider>
    );
};

export default withRouter(Login);
